import { render, staticRenderFns } from "./ToolbarLoader.vue?vue&type=template&id=6747348d&"
import script from "./ToolbarLoader.vue?vue&type=script&lang=js&"
export * from "./ToolbarLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports